import React from 'react'
import { DocsThemeConfig } from 'nextra-theme-docs'
import { MendableSearchBar } from '@mendable/search'

const config: DocsThemeConfig = {
    logo: <span>GetScraping.com API Docs</span>,
    project: {
        link: 'https://github.com/GetScraping'
    },
    // chat: {
    //     link: 'https://discord.com',
    // },
    // docsRepositoryBase: 'https://github.com/shuding/nextra-docs-template',
    footer: {
        text: 'GetScraping.com API Docs',
    },
    feedback: {
        useLink: () => 'mailto:feedback@getscraping.com',
    },
    editLink: {
        component: null,
    },
    search: {
        // component: (props) => <div {...props}><MendableSearchBar anon_key="" showSimpleSearch /></div>,
        placeholder: 'Search docs...',
    },
     
}

export default config;